import axios from "../axiosHelper";
import Cookies from "js-cookie";

export default {
  state: {
    status: "",
    status_code: "",
    message: "",
    message_code: "",
    modulList: [{}],
    modulDetail: {},
    userModule: {},
    userMaterialDuration: {},
    currentModulId: Cookies.get("currentModulId"),
  },
  getters: {
    getCurrentModulId: (state) => state.currentModulId,
    getModulList: (state) => state.modulList,
    getModulDetail: (state) => state.modulDetail,
    storeUserMaterial: (state) => state.userModule,
    storeUserMaterialDuration: (state) => state.userMaterialDuration,
  },
  mutations: {
    request(state) {
      state.status = "LOADING";
    },
    success(state, { resp }) {
      state.status = "SUCCESS";
      if (resp) {
        state.status_code = resp.data.status;
        state.message = resp.data.message;
        state.message_code = resp.data.code;
      }
    },
    error(state, { resp }) {
      state.status = "ERROR";
      if (resp) {
        state.status_code = resp.data.status;
        state.message = resp.data.message;
        state.message_code = resp.data.code;
      }
    },
    setModulList(state, { resp }) {
      if (resp) {
        state.modulList = resp.data.data;
      }
    },
    setModulDetail(state, { resp }) {
      if (resp) {
        state.modulDetail = resp.data.data;
      }
    },
    setCurrentModulId(state, { form }) {
      localStorage.setItem("currentModulId", form.modulId);
      Cookies.set("currentModulId", form.modulId);
    },
  },
  actions: {
    setCurrentModulId({ commit }, form) {
      commit("setCurrentModulId", { form });
    },
    deleteModul({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/learning-activity/delete?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getModulDetail({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/modul/get-overview/" + param.modulId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setModulDetail", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    storeUserMaterial({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/modul/store-user-material/" + param.materialId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    storeUserMaterialDuration({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/modul/store-user-modul-duration/" + param.materialId + "/" + param.duration + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    updateModul({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/learning-activity/edit?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    addModul({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/learning-activity/add?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
  },
};
